import createIcon from '../../createIcon';

/**
 * @component @name Battery2Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgNVYyMUMxNyAyMS41NSAxNi41NSAyMiAxNiAyMkg4QzcuNDUgMjIgNyAyMS41NSA3IDIxVjVDNyA0LjQ1IDcuNDUgNCA4IDRIMTBWMkgxNFY0SDE2QzE2LjU1IDQgMTcgNC40NSAxNyA1Wk0xNSA2SDlWMTZIMTVWNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Battery2Bar = createIcon('Battery2Bar', [
  [
    'path',
    {
      d: 'M17 5V21C17 21.55 16.55 22 16 22H8C7.45 22 7 21.55 7 21V5C7 4.45 7.45 4 8 4H10V2H14V4H16C16.55 4 17 4.45 17 5ZM15 6H9V16H15V6Z',
      key: '13e4oz',
    },
  ],
]);

export default Battery2Bar;
